const SvgComponent = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-label="עיגול מלא"
    >
      <path
        d="M5.00245 9.374C7.42245 9.374 9.35845 7.438 9.35845 5.018C9.35845 2.598 7.42245 0.662 5.00245 0.662C2.58245 0.662 0.646449 2.598 0.646449 5.018C0.646449 7.438 2.58245 9.374 5.00245 9.374Z"
        fill="#0089CF"
      />
    </svg>
  )
}

export default SvgComponent
